var styles = {"wrapper":"Wrapper-module_wrapper__hqhT9","coverPhoto":"Wrapper-module_coverPhoto__Ggg7W","pageLink":"Wrapper-module_pageLink__gqyQd"};

export { styles as default };
//# sourceMappingURL=Wrapper.module.scss.js.map
